// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Buefy from 'buefy'

import router from './router'
import axios from 'axios';
import store from './store/store';
import interceptor from './helpers/httpInterceptor.js';

import 'font-awesome/css/font-awesome.min.css'

//--------SETUP BUEFY---------//
Vue.use(Buefy, {
    defaultIconPack: 'fa',
    defaultDateFormatter: function(date) {
        return date.toLocaleDateString()
    }
})

interceptor();

axios.defaults.headers.post['Content-Type'] = 'application/json';
Vue.prototype.$http = axios;

Vue.config.productionTip = false

/* eslint-disable no-new */
var app = new Vue({
    el: '#app',
    router,
    store: store,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js